import React from 'react';

interface FacebookLogoSvgProps {
  size?: string;
}

export const FacebookLogoSvg = ({ size = '56px' }: FacebookLogoSvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" clipRule="evenodd" viewBox="0 0 2084 2084" height={size} width={size}>
    <path
      fill="#0866ff"
      d="M2083.33 1041.67C2083.33 466.374 1616.959 0 1041.66 0 466.364 0-.01 466.371-.01 1041.67c0 488.521 336.313 898.425 790.025 1010.99v-692.675h-214.8v-318.316h214.8V904.506c0-354.55 160.45-518.883 508.533-518.883 65.992 0 179.863 12.937 226.446 25.879V700.06c-24.587-2.587-67.287-3.883-120.342-3.883-170.804 0-236.799 64.7-236.799 232.917v112.575h340.245l-58.45 318.316h-281.795v715.721c515.775-62.296 915.47-501.462 915.47-1034.04"
    />
    <path
      fill="#fff"
      d="m1449.66 1359.99 58.454-318.317h-340.245V929.094c0-168.217 65.991-232.912 236.795-232.912 53.055 0 95.755 1.291 120.342 3.879V411.507c-46.583-12.942-160.454-25.884-226.446-25.884-348.079 0-508.533 164.338-508.533 518.888v137.162h-214.8v318.317h214.8v692.675c80.596 19.992 164.867 30.675 251.642 30.675 42.725 0 84.825-2.633 126.2-7.629V1359.99h281.791Z"
    />
  </svg>
);

